export default {
  inputStyle: {
    margin: "0.5rem 0 0 0 ",
  },
};
